<template>
    <div>

    <div class="row" id="business_information">
        <div class="col-12" v-if="!is_reviewing">
            <div class="panel-sub-heading headingLarge">
                <span class="h5 display-6 markedBottom bold">{{ lang('business_information') }}</span>
            </div>
        </div>

        <div class="col-lg-5 col-md-6 col-12" ref="block_about_business">
            <np-entry v-show="isRegNumberFirst && canQuoteShowRegNumber"
                      ref="reg_number"
                      :label="regNumberLabel"
                      mode="inline"
                      v-model="quote.reg_number">
            </np-entry>
            <np-entry
                    ref="ownership_entity_type"
                    :label="lang('business_type')"
                    :formatter="formatBusinessType"
                    mode="inline"
                    v-model="quote.ownership_entity_type">
            </np-entry>
            <np-entry
                    ref="legal_name"
                    :label="lang('legal_name')"
                    mode="inline"
                    v-model="quote.legal_name">
            </np-entry>
            <np-entry v-show="!isRegNumberFirst && canQuoteShowRegNumber"
                    ref="reg_number"
                    :label="regNumberLabel"
                    mode="inline"
                    v-model="quote.reg_number">
            </np-entry>
        </div>

            <div class="col-lg-7 col-md-6 col-12" ref="block_business_detail">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-12">
                    <np-entry
                        ref="business_sector"
                        :label="lang('business_sector')"
                        :formatter="formatBusinessSector"
                        mode="inline"
                        v-model="quote.business_sector">
                    </np-entry>
                  <np-entry
                      ref="new_to_card_payments"
                      :label="lang('new_to_card_payments')"
                      :formatter="formatBooleanOption"
                      mode="inline"
                      :model-value="quote.new_to_card_payments">
                  </np-entry>
                    <np-entry
                        ref="previous_acquirer"
                        :label="lang('previous_acquirer')"
                        :formatter="formatReverseBooleanOption"
                        mode="inline"
                        :model-value="quote.new_to_card_payments">
                    </np-entry>
                    <np-entry
                        v-if="is_girocard_only_active"
                        ref="girocard_only"
                        :label="lang('girocard_only')"
                        :formatter="formatBooleanOption"
                        mode="inline"
                        :model-value="quote.girocard_only">
                    </np-entry>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                    <np-entry
                        ref="mcc_iso"
                        :label="lang('mcc_iso')"
                        :formatter="formatMCC"
                        mode="inline"
                        v-model="quote.mcc_iso">
                    </np-entry>
                    <np-entry
                        ref="payment_method"
                        :label="lang('card_acceptance_method')"
                        :formatter="formatCardAcceptanceMethod"
                        mode="inline"
                        :model-value="quote.payment_method">
                    </np-entry>
                </div>
            </div>
        </div>
        <div class="col-lg-5 col-md-6 col-12">
            <div class="row" ref="block_turnover">
                <div class="col-lg-12 col-md-12 col-12">
                    <div class="panel-sub-heading headingSmall">
                        <span class="markedBottom">{{lang('business_turnover')}}</span>
                    </div>
                    <np-entry ref="annual_turnover"
                              :label="lang('annual_turnover')"
                              mode="inline"
                              :formatter="formatCurrencyValue"
                              :model-value="quote.annual_turnover">
                    </np-entry>
                    <np-entry ref="monthly_card_turnover"
                              :label="lang('monthly_card_turnover')"
                              mode="inline"
                              :formatter="formatCurrencyValue"
                              :model-value="quote.monthly_card_turnover">
                    </np-entry>
                    <np-entry ref="avg_ticket_sales_amt"
                              :label="lang('field_business_average_transaction_value')"
                              mode="inline"
                              :formatter="formatCurrencyValue"
                              :model-value="quote.avg_tran_value">
                    </np-entry>
                </div>
            </div>
            <div class="row" ref="block_transactions" v-if="!quoteIsEcom  || isBlendedMid">
                <div class="col-lg-12 col-md-12 col-12">
                <div class="panel-sub-heading headingSmall">
                    <span class="markedBottom">{{lang('transaction')}}</span>
                </div>
                <np-entry :label="lang('sales_ftf_perc')"
                          mode="inline"
                          ref="sales_ftf_perc"
                          :formatter="formatPercentValue"
                          :model-value="quote.sales_ftf_perc">
                </np-entry>
                <np-entry :label="lang('sales_moto_perc')"
                          mode="inline"
                          ref="sales_moto_perc"
                          :formatter="formatPercentValue"
                          :model-value="quote.sales_moto_perc">
                </np-entry>
                <np-entry v-if="isBlendedMid"
                          :label="lang('sales_internet_perc')"
                          mode="inline"
                          ref="sales_internet_perc"
                          :formatter="formatPercentValue"
                          :model-value="quote.sales_internet_perc">
                </np-entry>
                </div>
            </div>
            <div class="row" ref="block_application_options">
              <div class="col-12">
                <div class="panel-sub-heading headingSmall">
                  <span class="markedBottom">{{ lang('application_options') }}</span>
                </div>
              </div>
              <div class="col-12">
                <np-entry
                    :label="lang('marketing_opt_in')"
                    ref="marketing_opt_in"
                    mode="inline"
                    :model-value="quote.marketing_opt_in"
                    :formatter="formatBooleanOption">
                </np-entry>
              </div>
            </div>
        </div>
        <div class="col-lg-7 col-md-6 col-12" ref="block_personal_information">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-12">
                            <div class="panel-sub-heading headingSmall"><span
                                    class="markedBottom">{{lang('business_contact')}}</span>
                            </div>
                        </div>
                        <div class="col-md-12 col-12">
                            <div class="row">
                                <div class="col-lg-7 col-md-8 col-sm-12">
                                    <np-entry
                                            :label="lang('field_title')"
                                            :formatter="formatTitle"
                                            mode="inline"
                                            ref="owner_title"
                                            v-model="quote.contact_title">
                                    </np-entry>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-entry
                                            :label="lang('field_first_name')"
                                            mode="inline"
                                            ref="owner_first_name"
                                            v-model="quote.contact_first_name">
                                    </np-entry>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-entry
                                            :label="lang('field_middle_name')"
                                            mode="inline"
                                            ref="owner_second_name"
                                            v-model="quote.contact_second_name">
                                    </np-entry>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-entry
                                            :label="lang('field_last_name')"
                                            mode="inline"
                                            ref="owner_surname"
                                            v-model="quote.contact_last_name">
                                    </np-entry>
                                </div>
                            </div>

                        </div>
                        <div class="col-md-12 col-12">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-entry
                                            :label="lang('field_email')"
                                            mode="inline"
                                            ref="owner_email"
                                            v-model="quote.email_address">
                                    </np-entry>
                                </div>
                                <div class="col-lg-6 col-md-6 col-12">
                                    <np-entry ref="owner_phone"
                                            :label="lang('phone')"
                                            mode="inline"
                                            :model-value="`${formatPhoneCode(quote.ent_telephone_code)} ${quote.telephone_number}`">
                                    </np-entry>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 col-12">
                            <div class="row">
                                <np-entry
                                    :label="lang('principals_sign_documents')"
                                    mode="inline"
                                    ref="multi_signer"
                                    v-model="quote.multi_signer">
                                </np-entry>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0" v-if="!is_reviewing">
            <div class="col-12">
                <div class="my-3">
                    <button type="button" class="btn btn-default me-1" @click="doContinue"> {{lang('continue')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import {
        NPEntry, NPResponsive,NPSkeleton,
    } from "netpify/components";
    import EcomPaymentMethod from "../../../components/ecom-payment-method.vue";

    export default {
        name: "viewBusinessInformation",
        mixins: [utilMixin, applicationMixin],
        components: {
            'np-entry': NPEntry,
            'np-responsive': NPResponsive,
            'np-skeleton': NPSkeleton,
            'ecom-payment-method': EcomPaymentMethod
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        data() {
            return {
                options: {
                    dotSize: 14,
                    width: 'auto',
                    height: 4,
                    contained: true,
                    direction: 'ltr',
                    data: null,
                    min: 0,
                    interval: 100,
                    disabled: false,
                    clickable: true,
                    duration: 0.5,
                    adsorb: true,
                    lazy: false,
                    tooltip: 'active',
                    tooltipPlacement: 'top',
                    tooltipFormatter: void 0,
                    useKeyboard: false,
                    keydownHook: null,
                    dragOnClick: false,
                    enableCross: true,
                    fixed: false,
                    minRange: void 0,
                    maxRange: void 0,
                    order: true,
                    marks: false,
                    dotOptions: void 0,
                    process: true,
                    dotStyle: void 0,
                    railStyle: void 0,
                    processStyle: void 0,
                    tooltipStyle: void 0,
                    stepStyle: void 0,
                    stepActiveStyle: void 0,
                    labelStyle: void 0,
                    labelActiveStyle: void 0,
                },
                provide_principal_details: '',
                principal_details_param: [
                    {
                        label: this.lang('can_provide_principal_details'),
                        value: '0'
                    },
                    {
                        label: this.lang('can_invite_principal_for_details'),
                        value: '1'
                    },
                ],
                bankTypes: [
                    {
                        label: this.lang('use_business_bank_account'),
                        value: 'BUSINESS',
                    },
                    {
                        label: this.lang('use_store_bank_account'),
                        value: 'OUTLET',
                    },
                ],
                bank_account_types_param: [
                    {'id': 'DEPOSIT', 'text': this.lang('savings')},
                    {'id': 'BILLING', 'text': this.lang('checking')}
                ],
                status: '',
                page_label: 'tell_us_bit_about_your_business',
                page_config_template: 'SelfBusinessCriteria',
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (!!vm.page_label) {
                    vm.setAppPageTitle(vm.page_label);
                }
            });
        },
        created (){
            this.pageConfig = this.page_config[this.page_config_template];
        },
        mounted() {
            this.runPageConfig(this.page_configuration[this.page_config_template], this);
            this.setOtherTitle(this.quote, true);
        },
        computed: {
            is_girocard_only_active: function () {
                return (this.allianceCountry === '276');
            },
            isCharity: function () {
                if (!!this.merchant && !!this.quote.ownership_entity_type) {
                    return this.quote.ownership_entity_type === this.business_types.TRUST || this.quote.ownership_entity_type === this.business_types.CHARITY;
                }

                return false;
            },
            can_process_german_ecom_payment: function () {
                return (this.quote.sales_internet_perc > 0 && this.allianceCountry === '276')
            },
        },
        methods: {
            doContinue: function () {
                let path_to = this.quote_root_path + 'business/products/';
                this.$router.push({path: path_to})
            },
        }
    }
</script>

<style>
</style>
